// extracted by mini-css-extract-plugin
export default {"wrap":"NotFound_wrap__QM1Jz"};